import * as Sentry from '@sentry/react';
import React, {useEffect} from 'react';
import {createPath, useLocation} from 'react-router';
import {FallbackPage} from './FallbackPage/FallbackPage';

const loadTime = performance.now();

export function NotFoundPage() {
    const location = useLocation();
    useEffect(() => {
        const mountTime = performance.now();

        return () => {
            const unmountTime = performance.now();
            const visibilityTime = unmountTime - mountTime;
            Sentry.captureMessage('User encountered "Not Found" page', {
                extra: {
                    'Time since load': unmountTime - loadTime,
                    'Duration page seen': visibilityTime,
                    'Location path': createPath(location),
                },
            });
        };
    }, []);

    return (
        <FallbackPage
            title='Page not found'
            message='We couldn’t find the page you’re looking for. Please return to the home screen.'
        />
    );
}
